import {Alert, Button, Col, Drawer, Row, Space, Tooltip} from "antd";
import {CloseOutlined, QuestionCircleOutlined} from "@ant-design/icons";
import {Fragment, useState} from "react";
import {StyledRevenueListItem} from "./revenue-section.style";
import {usePricingCurrencies} from "@/features/currencies";
import {useGetStoreServiceSalesAndInsightsApi} from "../../../../../react-query-hooks/store/services/get-store-service-sales-and-insights";
import {StyledCustomersDataBox} from "../../../../../styles/customers/customers";

type StoreServiceSalesAndInsightsRevenueSectionProps = {
  storeServiceId: number;
};

export function StoreServiceSalesAndInsightsRevenueSection({
  storeServiceId,
}: StoreServiceSalesAndInsightsRevenueSectionProps) {
  const [openRevenueBreakDown, setOpenRevenueBreakDown] = useState(false);
  const pricingCurrencies = usePricingCurrencies();
  const getStoreServiceSalesAndInsightsApi =
    useGetStoreServiceSalesAndInsightsApi(storeServiceId);

  if (getStoreServiceSalesAndInsightsApi.isLoading) {
    return <>Loading...</>;
  }

  if (getStoreServiceSalesAndInsightsApi.isError) {
    return (
      <Alert type="error" message={getStoreServiceSalesAndInsightsApi.error.message} />
    );
  }

  const showRevenueBreakDown = () => {
    setOpenRevenueBreakDown(true);
  };

  const onCloseRevenueBreakDown = () => {
    setOpenRevenueBreakDown(false);
  };

  const handleDefaultPayoutCurrency = () => {
    if (pricingCurrencies.bankAccount?.currency) {
      return pricingCurrencies.bankAccount.currency;
    } else if (getStoreServiceSalesAndInsightsApi.data.totalRevenue[0].currency) {
      return getStoreServiceSalesAndInsightsApi.data.totalRevenue[0].currency;
    } else {
      return "NGN";
    }
  };

  const handleInsightAmount = () => {
    const currencyExists = getStoreServiceSalesAndInsightsApi.data.totalRevenue.find(
      (c) => c.currency === handleDefaultPayoutCurrency()
    );

    if (currencyExists) {
      return currencyExists.totalRevenue;
    } else {
      return 0;
    }
  };

  return (
    <div style={{marginTop: "2.4rem"}}>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        <Row gutter={[59, 20]}>
          <Col span={24} md={12}>
            <StyledCustomersDataBox
              style={{
                backgroundColor: "#EAE6F3",
                color: "#272037",
                borderRadius: "5px",
                border: "1.6px solid #43375D",
              }}
            >
              <div style={{backgroundColor: "#B3A8CD"}} className="data-circle"></div>
              <p className="data-box-title">
                Total revenue
                <Tooltip
                  placement="left"
                  title="Your total revenue is calculated in your payout currency"
                >
                  <Button icon={<QuestionCircleOutlined />} size="small" type="text" />
                </Tooltip>
              </p>
              <h2 className="data-box-value">{`${handleDefaultPayoutCurrency()} ${handleInsightAmount().toLocaleString()}`}</h2>
            </StyledCustomersDataBox>
          </Col>
          <Col span={24} md={12}>
            <StyledCustomersDataBox
              style={{
                backgroundColor: "#E7EDE1",
                color: "#16350F",
                borderRadius: "5px",
                border: "1.6px solid #355D2C",
              }}
            >
              <div style={{backgroundColor: "#B6C2A8"}} className="data-circle"></div>
              <p className="data-box-title">
                Total sales
                <Tooltip placement="left" title="Total unit of products sold">
                  <Button icon={<QuestionCircleOutlined />} size="small" type="text" />
                </Tooltip>
              </p>
              <h2 className="data-box-value">
                {getStoreServiceSalesAndInsightsApi.data.totalPurchases}
              </h2>
            </StyledCustomersDataBox>
          </Col>
        </Row>
        {getStoreServiceSalesAndInsightsApi.data.totalRevenue.length > 0 && (
          <p style={{color: "#595959"}}>
            Check your earnings in all your currencies,{" "}
            <Button
              onClick={showRevenueBreakDown}
              style={{padding: "0"}}
              type="link"
              size="small"
            >
              click here
            </Button>{" "}
            to view
          </p>
        )}
      </Space>
      <Drawer
        title="Revenue breakdown"
        placement="right"
        onClose={onCloseRevenueBreakDown}
        visible={openRevenueBreakDown}
        // mask={false}
        closable={false}
        width={320}
        extra={
          <Button
            type="ghost"
            size="small"
            icon={<CloseOutlined />}
            onClick={onCloseRevenueBreakDown}
          ></Button>
        }
      >
        <Row gutter={[20, 16]}>
          {getStoreServiceSalesAndInsightsApi.data.totalRevenue.map((revenue) => (
            <Fragment key={revenue.currency}>
              <Col span={12}>
                <StyledRevenueListItem>
                  <div className="item-volume">
                    <p className="item-title">Total volume</p>
                    <p className="item-value">{`${
                      revenue.currency
                    } ${revenue.totalRevenue.toLocaleString("en-us")}`}</p>
                  </div>
                </StyledRevenueListItem>
              </Col>
              {/* <Col span={12}>
                <StyledRevenueListItem>
                  <div className="item-unit">
                    <p className="item-title">Total unit</p>
                    <p className="item-value">{revenue.}</p>
                  </div>
                </StyledRevenueListItem>
              </Col> */}
            </Fragment>
          ))}
        </Row>
      </Drawer>
    </div>
  );
}
